import _ from "lodash";

import Stack from "components/Stack";

import TransactionCollapseLine from "pages/Deal/FinancingEvents/TransactionCollapse/TransactionCollapseLine";
import { formatMoneyField } from "pages/Deal/FinancingEvents/TransactionCollapse/utils";

import { IEquityTransaction } from "entities/Deal/sdk";

interface IEquityTransactionCollapse {
  equityTransaction: IEquityTransaction;
}

const EquityTransactionCollapse = ({
  equityTransaction,
}: IEquityTransactionCollapse) => (
  <>
    <Stack display="grid" gridTemplateColumns="1fr 2fr" gap={1}>
      <TransactionCollapseLine
        name="Rate"
        value={
          !_.isNil(equityTransaction.rate)
            ? `${equityTransaction.rate}%`
            : "N/A"
        }
      />
      <TransactionCollapseLine name="Term" value={equityTransaction.term} />
      <TransactionCollapseLine
        name="Term type"
        value={equityTransaction.term_type}
      />
    </Stack>
    <Stack display="grid" gridTemplateColumns="1fr 1fr" gap={1}>
      <TransactionCollapseLine
        name="Housing credit equity"
        value={
          !_.isNil(equityTransaction.housing_credit_equity)
            ? formatMoneyField({
                currency: equityTransaction.housing_credit_equity.currency,
                amount: equityTransaction.housing_credit_equity.amount,
              })
            : "N/A"
        }
      />
      <TransactionCollapseLine
        name="Other sources"
        value={equityTransaction.other_sources}
      />
      <TransactionCollapseLine
        name="Other sources amount"
        value={
          !_.isNil(equityTransaction.other_sources_amount)
            ? formatMoneyField({
                currency: equityTransaction.other_sources_amount.currency,
                amount: equityTransaction.other_sources_amount.amount,
              })
            : "N/A"
        }
      />
    </Stack>
  </>
);

export default EquityTransactionCollapse;
